import { useUIColors } from '@/core/hooks';
import React from 'react';
import { StyleProp, StyleSheet, View, ViewProps, ViewStyle } from 'react-native';

export type OverlayType = 'dark' | 'gradient';

export interface OverlayProps extends Omit<ViewProps, 'style'> {
    type?: OverlayType;
    opacity?: number;
    style?: StyleProp<ViewStyle>;
}

export const Overlay = React.memo<OverlayProps>(function Overlay({
    type = 'dark',
    opacity = 0.5,
    style,
    children,
    ...props
}) {
    const colors = useUIColors();
    const getOverlayStyle = () => {
        switch (type) {
            case 'dark':
                return {
                    backgroundColor: colors.fontHighContrast,
                    opacity,
                };
            case 'gradient':
                return {
                    backgroundColor: 'transparent',
                    // Note: React Native doesn't support CSS gradients directly
                    // For gradients, we'll use react-native-linear-gradient when needed
                    opacity,
                };
            default:
                return {
                    backgroundColor: colors.fontHighContrast,
                    opacity,
                };
        }
    };

    return (
        <View
            style={[
                styles.overlay,
                getOverlayStyle(),
                style
            ]}
            {...props}
        >
            {children}
        </View>
    );
});

const styles = StyleSheet.create({
    overlay: {
        ...StyleSheet.absoluteFillObject,
    },
});

export default Overlay;
